let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZ22O")).then(() => parcelRequire('8K8sb'));